import { render } from "./support-tab.vue?vue&type=template&id=187956aa&scoped=true"
import script from "./support-tab.vue?vue&type=script&lang=js"
export * from "./support-tab.vue?vue&type=script&lang=js"

import "./support-tab.vue?vue&type=style&index=0&id=187956aa&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187956aa"]])

export default __exports__